import { DEFAULT_FEATURE, TYPE_CREDO_OPT_IN } from './constants';
export function redirect(href, replace) {
  if (global.BROWSER) {
    window.location.replace(href);
  } else {
    // eslint-disable-next-line global-require -- req
    const parsedHref = require('url').parse(href);
    replace({
      pathname: parsedHref.path,
      search: parsedHref.search,
      host: parsedHref.host,
      protocol: parsedHref.protocol,
      state: parsedHref
    });
  }
}
export const makeEligibilityArgs = _ref => {
  let {
    origin,
    mappedAccounts,
    feature = DEFAULT_FEATURE
  } = _ref;
  return {
    feature,
    origin,
    products: mappedAccounts
  };
};
export const makeReadMemberPreferencesArgs = _ref2 => {
  let {
    publicGuid,
    accountToken,
    types = [TYPE_CREDO_OPT_IN],
    timeout = 6000
  } = _ref2;
  return {
    publicGuid,
    accountToken,
    timeout,
    types: (types === null || types === void 0 ? void 0 : types.length) > 0 ? types : [TYPE_CREDO_OPT_IN]
  };
};
export const getMemberPreferenceByType = (preferences, preferenceType) => {
  var _preferences$find;
  return Array.isArray(preferences) && ((_preferences$find = preferences.find(_ref3 => {
    let {
      type
    } = _ref3;
    return type === preferenceType;
  })) === null || _preferences$find === void 0 ? void 0 : _preferences$find.value);
};